export default "__VITE_ASSET__Dd9vXpv___"